import {NgModule} from '@angular/core';
import {BlocksComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import {BlockElementsComponent} from './components/blockElements/item';
import {IconComponentModule} from '../ui/icon/item.module';
import {BlockElementImageComponent} from './components/blockElementImage/item';
import {BlockElementContainerComponent} from './components/blockElementContainer/item';
import {BlockElementIconComponent} from './components/blockElementIcon/item';
import {AvatarComponentModule} from '../ui/avatar/item.module';
import {BlockElementGroupComponent} from './components/blockElementGroup/item';
import {TabsComponentModule} from '../ui/tabs/item.module';
import {DirectivesModule} from 'app/core/directives/directives.module';
import {BlockElementGalleryComponent} from 'app/components/blocks/components/blockElementGallery/item';
import {FileSliderItemsComponentModule} from 'app/components/ui/file-slider-items/item.module';
import {BlockElementButtonComponent} from 'app/components/blocks/components/blockElementButton/item';
import {ButtonComponentModule} from 'app/components/ui/button/item.module';
import {BlockElementWorkerComponent} from 'app/components/blocks/components/blockElementWorker/item';
import {BlockElementLabelComponent} from 'app/components/blocks/components/blockElementLabel/item';
import {BlockElementArticleComponent} from 'app/components/blocks/components/blockElementArticle/item';
import {BlockElementLabelComponentModule} from 'app/components/blocks/components/blockElementLabel/item.module';

@NgModule({
  imports: [
    IonicModule,
    NgStyle,
    NgClass,
    NgIf,
    NgForOf,
    IconComponentModule,
    AvatarComponentModule,
    TabsComponentModule,
    DirectivesModule,
    FileSliderItemsComponentModule,
    ButtonComponentModule,
    BlockElementLabelComponentModule
  ],
  exports: [
    BlocksComponent,
    BlockElementsComponent,
    BlockElementIconComponent,
    BlockElementContainerComponent,
    BlockElementGroupComponent,
    BlockElementGalleryComponent,
    BlockElementButtonComponent,
    BlockElementWorkerComponent,
    BlockElementArticleComponent,
    BlockElementImageComponent
  ],
  declarations: [
    BlocksComponent,
    BlockElementsComponent,
    BlockElementIconComponent,
    BlockElementContainerComponent,
    BlockElementGroupComponent,
    BlockElementGalleryComponent,
    BlockElementButtonComponent,
    BlockElementWorkerComponent,
    BlockElementArticleComponent,
    BlockElementImageComponent
  ],
  providers: [],
})
export class BlocksComponentModule {

}
